import { Color, DisplayMode, Engine } from "excalibur";
import { TitleScene } from "./scenes/TitleScene";
import { InstructionsScene } from "./scenes/InstructionsScene";
import { GameScene } from "./scenes/GameScene";
import { VictoryScene } from "./scenes/VictoryScene";
import { GameOverScene } from "./scenes/GameOverScene";
import { VISUALS } from "./config";
import { Resources } from "./resources";

/**
 * Riley vs Virus - Main Entry Point
 * 
 * A "Digital Therapeutic Artifact" - a Vampire Survivors-style game
 * designed for Riley Keith Mills during recovery from influenza.
 * 
 * The game gamifies the immune response, with the player controlling
 * a Macrophage fighting off viral infection.
 */

const game = new Engine({
  displayMode: DisplayMode.FillScreen,
  backgroundColor: Color.fromHex(VISUALS.COLORS.BACKGROUND),
  // pixelArt: true,
  antialiasing: true,
  scenes: {
    title: TitleScene,
    instructions: InstructionsScene,
    game: GameScene,
    victory: VictoryScene,
    gameover: GameOverScene,
  },
});

import { CustomLoader } from "./ui/CustomLoader";

const loader = new CustomLoader();
for (const res of Object.values(Resources)) {
  loader.addResource(res);
}

// Start at the title scene 
game.start(loader).then(() => {
  game.goToScene('title');
  console.log('Riley vs Virus initialized');
});